import React, { useState, useEffect } from 'react';
import { scaleBand, scaleLinear } from 'd3-scale';
import { max, group } from 'd3-array';
import Loading from '../loading';

const WorldCupScore = ({
    margin,
    totalScoreData,
    individualYearData,
    width,
    givenHeight
}) => {
    const [height, setHeight] = useState(givenHeight)
    const [givenYear, setGivenYear] = useState(null)
    const [yIndex, setYIndex] = useState(['Yindex'])
    const [data, setData] = useState(totalScoreData)
    const [yearly, setYearly] = useState('total')
    useEffect(() => setData(totalScoreData), [totalScoreData])
    const handleChange = (e, data) => {
        if (yearly === 'total') {
            const new_array = Array.from(group(individualYearData, d => d.Year)).filter(a => a[0] === data.Yindex)[0][1]
            const items = new_array.length
            const newHeight = items > 20 ? items % 20 * 30 + height : height
            setHeight(newHeight)
            setData(new_array)
            setGivenYear(data.Yindex)
            setYearly('year')
            setYIndex(['Yindex'])
        } else if (yearly === 'year') {
            const new_array = Array.from(group(individualYearData, d => d.Yindex)).filter(a => a[0] === data.Yindex)[0][1]
            const items = new_array.length
            const newHeight = items > 20 ? items % 20 * 30 + height : items < 10 ? 300 : height
            setHeight(newHeight)
            setData(new_array)
            setYearly('country')
            setYIndex('Year')
        } else {
            setYearly('total')
            setHeight(givenHeight)
            setData(totalScoreData)
            setYIndex(['Yindex'])
        }
    }
    const barColor = (finish, organizer) => {
        if (yearly !== 'total') {
            if (finish && organizer) {
                return '#71B340'
            }
            else if (finish) {
                return "#00A6ED"
            }
            else if (organizer) {
                return "#FFB400"
            }
            else {
                return "#EF4444"
            }
        } else {
            return "#EF4444"
        }

    }
    const home = () => {
        setYearly('total')
        setHeight(givenHeight)
        setData(totalScoreData)
        setYIndex(['Yindex'])
    }
    const xScale = data ? scaleLinear()
        .domain([0, max(data, d => d.TotalScore)])
        .range([0, width - margin.left - margin.right])
        : null
    const yScale = data ? scaleBand()
        .domain(data.map(a => a[yIndex]))
        .padding(0.3)
        .range([margin.top + 20, height])
        : null
    return (
        <div>
            {
                data
                    ?
                    <div>{yearly !== 'total' ?
                        <div className="">
                            <button
                                className="p-2 shadow-md w-1/3 m-2 rounded black transition duration-150 ease-in-out bg-green-400"
                                onClick={home}>Home</button>
                            <svg width="200"
                                height="100">
                                <rect fill="#71B340" width="20" height="20" y={30} />
                                <text x="25" y={45} stroke="black">Host and Winner</text>
                                <rect fill="#00A6ED" width="20" height="20" y={60} />
                                <text x="25" y={75} stroke="black">Winner</text>
                                <rect fill="#FFB400" width="20" height="20" />
                                <text x="25" y={15} stroke="black">Host</text>
                            </svg>
                        </div>
                        : <div></div>
                    }
                        <svg
                            className="transition duration-150 my-2 sm:my-4 my-6 rounded black dark:bg-gray-500 bg-gray-100"
                            width={width}
                            height={height}>
                            <text key="xScale" x={width / 1.2} y={margin.top - 5}>
                                Goals  →
                            </text>
                            {
                                yearly !== 'total' ?
                                    <text key="yScale" x={margin.left - 34} y={margin.top + 5}>
                                        {yearly === 'country' ? data[0]['Yindex'] : `Country`}
                                    </text> :
                                    <text key="yScale" x={margin.left - 34} y={margin.top + 5}>
                                        Year
                                    </text>
                            }
                            {
                                yearly === 'year' ?
                                    <text className="font-bold" key="Year" x={width / 2} y={margin.top - 2}>
                                        {givenYear}
                                    </text> :
                                    yScale.domain().map((a, index) => (
                                        <g key={`yTickGroup-${index}`}>
                                            <text
                                                className="xs:text-xs text-sm"
                                                dy="0.35em"
                                                key={`yTickName-${index}`}
                                                x={margin.left - 29}
                                                y={yScale(a) + yScale.bandwidth() / 2}>
                                                {a}
                                            </text>
                                        </g>
                                    ))
                            }
                            {
                                xScale.ticks().map((a, index) => (
                                    <g key={`xScaleTips-${index}`}
                                        transform={`translate(${margin.left},0)`}>
                                        <line
                                            className="stroke-current text-gray-400 dark:text-white"
                                            key={`tickLine-${index}`}
                                            x1={xScale(a)}
                                            y1={margin.top + 20}
                                            x2={xScale(a)}
                                            y2={height}
                                        />
                                        <text
                                            className="xs:text-xs text-sm"
                                            key={`xScaleText-${index}`}
                                            x={xScale(a)}
                                            y={margin.top + 18}
                                            textAnchor="middle">
                                            {a}
                                        </text>

                                    </g>
                                ))
                            }
                            {data.map((a, index) => (
                                <g key={`topGrouping-${index}`}
                                    fill={barColor(a.Finish, a.Organizer)}>
                                    <rect
                                        onClick={(event) => handleChange(event, a)}
                                        key={`goals-${index}`}
                                        x={margin.left}
                                        y={yScale(a[yIndex])}
                                        width={xScale(a.TotalScore)}
                                        height={yScale.bandwidth()}>
                                        <title key={`helperTextRect-${index}`}>
                                            {a.TotalScore}
                                        </title>
                                    </rect>
                                    <g transform={`translate(${margin.left},0)`}>
                                        {yearly === 'total' ? <text
                                            key={`GoalScoredText-${index}`}
                                            fill={yearly === "total" ? "#4B5563" : "#111827"}
                                            className="text-xs font-bold"
                                            x={xScale(a.TotalScore)}
                                            y={yScale(a.Yindex) + yScale.bandwidth() / 2}
                                            dy="0.35em">
                                            {a.TotalScore}
                                        </text> : <></>}
                                        <text
                                            onClick={(event) => handleChange(event, a)}
                                            key={`GoalScoredTextWinner-${index}`}
                                            textAnchor="middle"
                                            fill={yearly === "total" ? "#E5E7EB" : "#111827"}
                                            className="sm:font-bold"
                                            x={xScale(a.TotalScore) === 0 ? 25 : xScale(a.TotalScore) > 70 ? xScale(a.TotalScore) - 50 : xScale(a.TotalScore) + 30}
                                            y={yScale(a[yIndex]) + yScale.bandwidth() / 2}
                                            dy="0.35em">
                                            {yearly === 'year' ?
                                                a[yIndex] : yearly === 'country' ? a.TotalScore :
                                                    a.Winner}
                                        </text>
                                    </g>
                                </g>
                            ))}
                            {
                                yearly === 'total'
                                    ?
                                    <g>
                                        <rect key="index"
                                            className="fill-current text-red-500 dark:text-gray-700"
                                            x={width / 1.5}
                                            y={height / 10}
                                            width="90"
                                            height={yScale.bandwidth()}>
                                        </rect>

                                        <text
                                            className="fill-current text-gray-200 dark:text-white font-bold"
                                            x={(width / 1.5) + 10}
                                            y={(height / 10) + yScale.bandwidth() / 1.4}>Winners</text>
                                    </g>
                                    : <></>
                            }
                        </svg>
                    </div>
                    :
                    <Loading />
            }
        </div >

    )
}

export default WorldCupScore